import React from "react";

/**
 * DS ButtonWide — figma 298:4259 "button-wide".
 *
 * white bg + border Default, radius 12 (note: 다른 버튼은 6), gap 6
 * padding: pl=16 pr=20 py=16 (54h)
 * 아이콘 16×16 + 텍스트 Pretendard SemiBold 14/22 Text/Secondary, center 정렬
 *
 * 카드 최하단의 "+ 옵션 추가" / "+ 사이드메뉴 추가" / "+ 항목 추가" 와이드 버튼에 사용.
 * width: 100% (parent에서 결정).
 *
 * @param {object} props
 * @param {React.ReactNode} [props.icon]
 * @param {React.ReactNode} props.children
 * @param {() => void} [props.onClick]
 * @param {boolean} [props.disabled]
 */
const DSButtonWide = ({ icon, children, onClick, disabled, className = "" }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`ds-button-wide ${className}`}
    >
      {icon && <span className="ds-button-wide__icon">{icon}</span>}
      <span>{children}</span>
    </button>
  );
};

export default React.memo(DSButtonWide);
